export var hexToRgb = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex), _a = result.map(function (val) { return parseInt(val, 16); }), r = _a[1], g = _a[2], b = _a[3];
    return result ? { r: r, g: g, b: b } : null;
};
export var splitSliceJoin = function (string, start, end) { return string.split('').slice(start, end).join(''); };
// if hex and defined as #fff then convert it to standard 7 letter format #ffffff
export var fixedHexFormat = function (arr) {
    return arr.map(function (c) {
        if (c.length === 4) {
            return "#" + (c[1] + c[1] + c[2] + c[2] + c[3] + c[3]);
        }
        else if (c.length === 7) {
            return c;
        }
    });
};
// get r,g,b,h,s and l with Bezier interpolation
// https://www.cl.cam.ac.uk/teaching/2000/AGraphHCI/SMEG/node3.html
// Check issue #3 for more info
export var propBezInterpolate = function (charArr) {
    return function (colArr) {
        return function (x) {
            var y = 1 - x, v;
            return charArr.map(function (c) {
                if (colArr.length == 2) {
                    v = (y * colArr[0][c]) + (x * colArr[1][c]);
                }
                else if (colArr.length == 3) {
                    v = ((Math.pow(y, 2)) * colArr[0][c]) + (2 * y * x * colArr[1][c]) + ((Math.pow(x, 2)) * colArr[2][c]);
                }
                else if (colArr.length == 4) {
                    v = ((Math.pow(y, 3)) * colArr[0][c]) + (3 * (Math.pow(y, 2)) * x * colArr[1][c]) + (3 * y * (Math.pow(x, 2)) * colArr[2][c]) + ((Math.pow(x, 3)) * colArr[3][c]);
                }
                return Math.trunc(v);
            });
        };
    };
};
export var extractHEX = function (arr) { return fixedHexFormat(arr).map(function (c) { return hexToRgb(c); }); };
export var extractRGB = function (arr) {
    return arr.map(function (c) {
        var _a = splitSliceJoin(c, 4, -1).split(','), r = _a[0], g = _a[1], b = _a[2];
        return { r: r, g: g, b: b };
    });
};
export var extractHSL = function (arr) {
    return arr.map(function (c) {
        c = splitSliceJoin(c, 4, -1).split(',');
        var h = c[0], s = splitSliceJoin(c[1], 0, -1), l = splitSliceJoin(c[2], 0, -1);
        return { h: h, s: s, l: l };
    });
};
export var returnRGBStr = function (arr) { return "rgb(" + arr[0] + ", " + arr[1] + ", " + arr[2] + ")"; };
export var returnHSLStr = function (arr) { return "hsl(" + arr[0] + ", " + arr[1] + "%, " + arr[2] + "%)"; };
//# sourceMappingURL=utils.js.map